import { Card, Text } from '@nike/eds'
import { get } from '../../../common/components/properties/Properties'
import './ShipmentDetails.scss'
import { DetailsField } from '../../../common/components/fields/DetailsField'

export function OrderDetails({ shipment }) {
  return (
    <div>
      <Text as="h2" font="title-3" style={{ margin: '0 0 20px 12px' }} className="vcenter">
        Order Details
      </Text>
      <Card className="flex-row content-space-between order-details-fields" padding={12}>
        <DetailsField
          list={get(shipment?.deliveries, 'salesOrderNumber')}
          label="Sales Order Number"
        />
        <DetailsField
          list={get(shipment?.deliveries, 'nikeSalesOrderTypeCode')}
          label="Order Type"
        />
        <DetailsField
          list={get(shipment?.deliveries, 'purchaseOrderNumber')}
          label="Purchase Order Number"
        />
        <DetailsField
          list={get(shipment?.deliveries, 'deliveryNoteNumber')}
          label="Delivery Note Number"
        />
      </Card>
    </div>
  )
}
